// extracted by mini-css-extract-plugin
module.exports = {"moveRight":"Mapping_moveRight_Xfapn","moveLeft":"Mapping_moveLeft_3eHKi","dataTableCon":"Mapping_dataTableCon_28SXA","headingBold":"Mapping_headingBold_3nFWc"};